import { GrowthBook } from "@growthbook/growthbook";
import {autoAttributesPlugin, growthbookTrackingPlugin} from "@growthbook/growthbook/plugins";

export interface AppFeatures {
    "show-standings-home": boolean;
    "show-featured-event": boolean;
    "show-news-home": boolean;
    "event-program-cta-copy": string;
}

export const growthbook = new GrowthBook<AppFeatures>({
    apiHost: import.meta.env.VITE_GROWTHBOOK_API_HOST || "https://cdn.growthbook.io",
    clientKey: import.meta.env.VITE_GROWTHBOOK_CLIENT_KEY || "sdk-KfW7AyM3viIbKIz6",
    enableDevMode: import.meta.env.VITE_GROWTHBOOK_DEV_MODE === "true",
    plugins: [
        autoAttributesPlugin(),
        growthbookTrackingPlugin(),
    ],

    trackingCallback: (experiment, result) => {
        console.log("trackingCallback GrowthBook experiment viewed", {
            experimentId: experiment.key,
            variationId: result.key,
            featureId: result.featureId,
        });
    },
});